"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBus = function SvgBus(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 19 13",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.636 9.426h-8.34S0 9.54 0 8.108V1.292S.094 0 1.27 0h12.334s1.648-.03 1.95 1.58c.303 1.611.553 3.037.553 3.037S17 4.996 17 6.148v2.313s.029.943-.927.943c-.957 0-6.437.022-6.437.022z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.091,
    cy: 9.429,
    fill: "#FFF",
    rx: 1.545,
    ry: 1.571
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.909,
    cy: 9.429,
    fill: "#FFF",
    rx: 1.545,
    ry: 1.571
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.318,
    height: 2.143,
    x: 1.273,
    y: 2.071,
    fill: "#FFF",
    rx: 0.659
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.318,
    height: 2.143,
    x: 4.364,
    y: 2.071,
    fill: "#FFF",
    rx: 0.659
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.318,
    height: 2.143,
    x: 7.455,
    y: 2.071,
    fill: "#FFF",
    rx: 0.659
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.455 1.571h-1.81s-.496-.008-.496.562v1.996s-.142.585.517.585h2.586M10.05 9.452V2.408s-.139-.837 1.102-.837c1.24 0 1.212.628 1.212.628v7.253m-1.159-.023V1.964"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgBus);
var _default = Memo;
exports["default"] = _default;